import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';

const API_BASE = process.env.REACT_APP_BACKEND_URL ?? '';
const TYPE_ORDER = ['XS', 'S', 'M', 'L', 'XL', 'XXL'];

export default function AvailabilityMatrix() {
  const [warehouses, setWarehouses] = useState([]);
  const [types, setTypes] = useState([]);
  const [matrix, setMatrix] = useState({});
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    Promise.all([
      axios.get(`${API_BASE}/api/warehouses`).then(r => r.data),
      axios.get(`${API_BASE}/api/box-types`).then(r => r.data),
      axios.get(`${API_BASE}/api/boxes/availability`).then(r => r.data),
    ]).then(([w, t, m]) => {
      // порядок как в бронировании: по sort_order, затем по коду
      setWarehouses([...w].sort((a, b) => (a.sort_order || 0) - (b.sort_order || 0) || a.code.localeCompare(b.code)));
      setTypes(t.sort((a, b) => TYPE_ORDER.indexOf(a.code) - TYPE_ORDER.indexOf(b.code)));
      setMatrix(m);
    }).finally(() => setLoading(false));
  }, []);

  if (loading) return null;

  return (
    <div className="mb-12 bg-card border border-border p-6" style={{ boxShadow: '4px 4px 0px 0px rgba(0,0,0,1)' }}>
      <div className="flex items-end justify-between mb-4 flex-wrap gap-2">
        <div>
          <h2 className="text-2xl font-sans font-bold uppercase">Доступность в реальном времени</h2>
          <p className="font-mono text-xs text-muted-foreground mt-1">Сколько боксов каждого типа сейчас свободно</p>
        </div>
        <Link to="/booking" className="px-4 py-2 bg-foreground text-background border-2 border-foreground font-mono text-xs uppercase tracking-widest hover:bg-accent hover:border-accent">
          Забронировать →
        </Link>
      </div>

      <div className="overflow-x-auto">
        <table className="w-full text-sm font-mono border-collapse">
          <thead>
            <tr className="border-b-2 border-foreground">
              <th className="p-3 text-left text-xs uppercase tracking-widest">Ячейка</th>
              {types.map(t => (
                <th key={t.code} className="p-3 text-center text-xs uppercase">
                  <div className="text-base font-bold">{t.code}</div>
                  <div className="text-[10px] text-muted-foreground normal-case">{t.size_m2} м² · {t.price_month.toLocaleString('ru-RU')}₽</div>
                </th>
              ))}
              <th className="p-3 text-center text-xs uppercase">Всего</th>
            </tr>
          </thead>
          <tbody>
            {warehouses.map((w, i) => {
              const wh = matrix[w.code] || {};
              const total = Object.values(wh).reduce((a, b) => a + b, 0);
              const soon = w.coming_soon === 1 || w.coming_soon === true;
              if (soon) {
                return (
                  <tr key={w.code} className={`border-b border-border ${i % 2 === 0 ? 'bg-muted/30' : ''}`}>
                    <td className="p-3 align-top">
                      <div className="font-bold">{w.name}</div>
                      <div className="text-[10px] text-muted-foreground">{w.address}</div>
                    </td>
                    <td colSpan={types.length + 1} className="p-3 text-center">
                      <span className="inline-block px-3 py-1 bg-accent text-white font-bold uppercase tracking-wider text-xs border-2 border-foreground">
                        🔜 Скоро открытие
                      </span>
                    </td>
                  </tr>
                );
              }
              return (
                <tr key={w.code} className={`border-b border-border ${i % 2 === 0 ? 'bg-muted/30' : ''}`}>
                  <td className="p-3 align-top">
                    <div className="font-bold">{w.name}</div>
                    <div className="text-[10px] text-muted-foreground">{w.address}</div>
                  </td>
                  {types.map(t => {
                    const cnt = wh[t.code] || 0;
                    return (
                      <td key={t.code} className="p-3 text-center">
                        {cnt > 0 ? (
                          <Link to={`/booking?warehouse=${w.code}&type=${t.code}`}
                            className="inline-block px-2 py-1 bg-accent/10 border border-accent text-accent font-bold hover:bg-accent hover:text-white transition-colors">
                            {cnt}
                          </Link>
                        ) : (
                          <span className="text-muted-foreground/50">—</span>
                        )}
                      </td>
                    );
                  })}
                  <td className="p-3 text-center font-bold">{total}</td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>

      <p className="mt-3 font-mono text-[11px] text-muted-foreground">
        Кликните по цифре чтобы выбрать конкретный бокс этого типа в выбранной ячейке.
      </p>
    </div>
  );
}
